import Immutable from 'immutable';

const elementKeys = Immutable.List(['segments', 'sequences', 'tokens']);

export const getElementPath = (elementIndexes) => (
    elementKeys.zipWith(Immutable.List.of.bind(Immutable.List), elementIndexes).flatten()
);

export const setInEach = (state, elementIndexes, valuePath, value) => {
    elementIndexes.forEach((_, index) => {
        state = state.setIn(
            getElementPath(elementIndexes.slice(0, index + 1)).concat(valuePath),
            value,
        );
    });
    return state;
};

export const findIndexByTime = (elements, currentTime, left = 0, right = null) => {
    if (right === null) right = elements.size - 1;
    if (left > right) return Math.max(0, right);

    const index = left + Math.floor((right - left) / 2);
    const element = elements.get(index);
    const startTime = element.get('startTime');
    const endTime = element.get('endTime');
    const active = startTime !== endTime && startTime <= currentTime && currentTime < endTime;

    if (active) return index;
    if (currentTime < startTime) return findIndexByTime(elements, currentTime, left, index - 1);
    return findIndexByTime(elements, currentTime, index + 1, right);
};

export const findIndexByExactTime = (elements, time, timeKey = 'startTime', left = 0, right = null) => {
    if (right === null) right = elements.size - 1;
    if (left > right) return -1;

    const index = left + Math.floor((right - left) / 2);
    const element = elements.get(index);
    const elementTime = element.get(timeKey);

    if (elementTime === time) return index;
    if (time < elementTime) return findIndexByExactTime(elements, time, timeKey, left, index - 1);
    return findIndexByExactTime(elements, time, timeKey, index + 1, right);
};

export const getTokenPathByTime = (state, currentTime) => {
    const path = [];
    elementKeys.forEach(key => {
        const searchPath = getElementPath(path).concat([key]);
        const index = findIndexByTime(state.getIn(searchPath), currentTime);
        if (index >= 0) return path.push(index);
        return false;
    });
    console.log({"Debug currentTime": currentTime, "path": path});
    return path;
};



// WEBPACK FOOTER //
// ./scripts/store/element-list/helpers.js